// src/config/siteConfig.js - Main business configuration
export const siteConfig = {
  // Company Information
  company: {
    name: "Booker.Chat",
    tagline: "Never Miss Another Booking Again",
    description: "AI-powered booking assistant for appointment-based businesses",
    phone: "647-771-3817",
    email: "mockwitinc@gmail.com",
    address: "Mississauga, ON"
  },

  // Branding & Design
  branding: {
    primaryColor: "#2563EB",      // Blue-600
    secondaryColor: "#10B981",    // Green-500  
    accentColor: "#F59E0B",       // Amber-500
    logoIcon: "Calendar",         // Lucide icon name
    favicon: "/favicon.ico"
  },

  // Pricing Plans
  pricing: {
    trialDays: 14,
    currency: "USD",
    plans: [
      {
        id: "plan1",
        name: "WhatsApp Only",
        price: { monthly: 79, yearly: 790 },
        description: "Perfect for small businesses starting with WhatsApp booking",
        features: [
          { text: "WhatsApp booking automation" },
          { text: "Calendar integration (Google Calendar)" },
          { text: "Basic appointment reminders" },
          { text: "Real-time availability checking" },
          { text: "Basic analytics dashboard" },
          { text: "Email support" },
          { text: "Up to 100 bookings/month" }
        ],
        limitations: [
          "No phone call handling",
          "No promotional campaigns", 
          "No payment processing"
        ],
        popular: false
      },
      {
        id: "plan2", 
        name: "WhatsApp + Voice",
        price: { monthly: 159, yearly: 1590 },
        description: "Most popular - Full booking assistant with phone support",
        features: [
          { text: "Everything in WhatsApp Only" },
          { text: "Phone call booking automation" },
          { text: "Advanced AI voice assistant" },
          { text: "Priority phone routing" },
          { text: "Advanced analytics & insights" },
          { text: "Customer behavior tracking" },
          { text: "Priority email & chat support" },
          { text: "Up to 300 bookings/month" },
          { text: "Custom greeting messages" },
          { text: "Multi-language support" }
        ],
        limitations: [
          "No promotional campaigns",
          "No payment processing"
        ],
        popular: true
      },
      {
        id: "plan3",
        name: "+ Marketing & Promotions", 
        price: { monthly: 259, yearly: 2590 },
        description: "Grow your business with automated marketing campaigns",
        features: [
          { text: "Everything in WhatsApp + Voice" },
          { text: "Automated promotional campaigns", comingSoon: true },
          { text: "Customer segmentation", comingSoon: true },
          { text: "Birthday & anniversary reminders", comingSoon: true },
          { text: "Review request automation", comingSoon: true },
          { text: "Advanced customer insights" },
          { text: "Social media integration", comingSoon: true },
          { text: "A/B testing for promotions", comingSoon: true },
          { text: "Up to 500 bookings/month" },
          { text: "Dedicated account manager" },
          { text: "Phone support" }
        ],
        limitations: [
          "No payment processing"
        ],
        popular: false
      },
      {
        id: "plan4",
        name: "+ Advanced Payments",
        price: { monthly: 300, yearly: 3000 },
        description: "Complete business solution with integrated payments", 
        features: [
          { text: "Everything in + Marketing & Promotions" },
          { text: "Integrated payment processing", comingSoon: true },
          { text: "Automatic payment collection", comingSoon: true },
          { text: "Deposit and prepayment handling", comingSoon: true },
          { text: "Subscription billing for memberships", comingSoon: true },
          { text: "Advanced financial reporting", comingSoon: true },
          { text: "Tax reporting integration", comingSoon: true },
          { text: "Refund management", comingSoon: true },
          { text: "Unlimited bookings" },
          { text: "Priority support (24/7)" },
          { text: "Custom integrations available" }
        ],
        limitations: [],
        popular: false
      }
    ]
  },

  // Target Industries
  industries: [
    { id: "barbershop", name: "Barbershop", icon: "✂️" },
    { id: "hair_salon", name: "Hair Salon", icon: "💇‍♀️" },
    { id: "nail_salon", name: "Nail Salon", icon: "💅" },
    { id: "spa", name: "Spa", icon: "🧖‍♀️" },
    { id: "beauty_studio", name: "Beauty Studio", icon: "💄" },
    { id: "other", name: "Other", icon: "🏪" }
  ],

  // Contact & Support
  contact: {
    supportEmail: "mockwitinc@gmail.com",
    salesEmail: "mockwitinc@gmail.com",
    legalEmail: "mockwitinc@gmail.com",
    securityEmail: "mockwitinc@gmail.com",
    supportPhone: "647-771-3817",
    liveChatEnabled: true,
    supportHours: "Monday-Friday 8AM-8PM EST"
  },

  // Social Media & Links
  social: {
    twitter: "https://twitter.com/Booker.Chat",
    linkedin: "https://linkedin.com/company/Booker.Chat", 
    facebook: "https://facebook.com/Booker.Chat",
    youtube: "https://youtube.com/Booker.Chat"
  },

  // Features & Benefits
  features: {
    mainBenefits: [
      {
        title: "Never Miss Calls",
        description: "24/7 AI assistant handles booking calls even when you're busy or closed",
        icon: "Phone"
      },
      {
        title: "Prevent Double Bookings", 
        description: "Real-time calendar integration prevents scheduling conflicts",
        icon: "Calendar"
      },
      {
        title: "Save Time",
        description: "Focus on serving customers instead of answering phones all day",
        icon: "Clock"
      }
    ],
    keyFeatures: [
      "WhatsApp & phone booking",
      "Google Calendar integration", 
      "Automatic reminders",
      "Multi-language support",
      "Payment processing",
      "Marketing automation"
    ]
  },

  // Testimonials
  testimonials: [
    {
      quote: "Imagine never losing a booking to a missed call again — that's exactly what Lisa does for us.",
      author: "Early Access Preview",
      business: "Hair Salon, Mississauga ON",
      rating: 5
    },
    {
      quote: "Our customers already use WhatsApp every day. Having them book through it just makes sense.",
      author: "Early Access Preview",
      business: "Barbershop, Mississauga ON",
      rating: 5
    },
    {
      quote: "The AI handles bookings at 2am so we don't have to. It just works.",
      author: "Early Access Preview",
      business: "Nail Spa, Mississauga ON",
      rating: 5
    }
  ],

  // Legal & Compliance
  legal: {
    companyName: "Booker.Chat",
    foundedYear: 2024,
    lastUpdated: "July 1, 2026",
    privacyPolicyVersion: "1.0",
    termsVersion: "1.0"
  }
};
